import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { isChatFeatureConfigured } from '@account-verification-frontend/types';
import { PendingIcon } from '../../icons';
import { CUSTOMER_SUPPORT_URL, UPLOAD_DOCUMENT_URL } from '../../constants';
import { LiveMessagingLink } from '../../components/LiveMessagingLink';
import './RejectedStep.scss';
export const RejectedStep = ({ userName }) => {
    const { t } = useTranslation();
    const isChatEnabled = isChatFeatureConfigured();
    const handleNavigateToSupport = () => {
        window.open(UPLOAD_DOCUMENT_URL, '_self');
    };
    return (React.createElement("div", { className: "rejected-step" },
        React.createElement(PendingIcon, { width: 64, height: 64, fill: "#FCE1A4" }),
        React.createElement("h2", { className: "rejected-step__title" }, t('rejected-step.title')),
        React.createElement("p", { className: "rejected-step__description" }, t('rejected-step.name', { name: userName })),
        React.createElement("p", { className: "rejected-step__description" }, t('rejected-step.description')),
        React.createElement("p", { className: "rejected-step__description" }, t('rejected-step.note')),
        React.createElement("p", { className: "rejected-step__description" },
            React.createElement(Trans, { i18nKey: "rejected-step.subDescription", components: [React.createElement("a", { key: "link", href: CUSTOMER_SUPPORT_URL, target: "_blank", rel: "noopener noreferrer" })] })),
        isChatEnabled ? React.createElement(LiveMessagingLink, null) : null,
        React.createElement("button", { className: "rejected-step__button", onClick: handleNavigateToSupport }, t('rejected-step.upload_documents'))));
};
//# sourceMappingURL=RejectedStep.js.map